import React from "react";
// import Swal from "sweetalert2";
// import Swal from 'sweetalert2/dist/sweetalert2.js'
import Swal from "sweetalert2/dist/sweetalert2.all";
import "./MessageAlert.css";

const MessageAlert = {
  confirm: ({
    title = "Confirm",
    message,
    html,
    confirmButtonText = "OK",
    cancelButtonText = "Cancel",
    onConfirm,
    hidenIcon = false,
  }) => {
    return Swal.fire({
      title: title,
      text: message,
      html: html,
      icon: hidenIcon ? null : "question",
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      reverseButtons: true,
      showCloseButton: false,
      focusConfirm: false,
      customClass: {
        icon: "icon-class",
        title: "title-class",
        content: "my-text-class",
        // confirmButton: "my-button-class",
        // cancelButton: "my-button-class",
        confirmButton: "my-button-class",
        cancelButton: "my-button-cance-class",
      },
      allowOutsideClick: false,
      preConfirm: () => {
        if (onConfirm) {
          return new Promise(async (resolve, reject) => {
            try {
              let icon = Swal.getIcon();
              if (icon) {
                icon.innerHTML = ` <div class="spinner-border" style="width: 5rem; height: 5rem; border-width: 0.5rem; color: #787878 !important;" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>`;
                icon.style.setProperty("border-color", "white", "important");
              }
              resolve(await onConfirm());
            } catch (error) {
              resolve(error);
            }
          });
        }
      },
    });
  },
  error: (options) => {
    const {
      title = "Error",
      message = "Oops, Something went wrong. Please try again later.",
      html,
    } = options || {};
    return Swal.fire({
      title: title,
      text: message,
      html: html,
      icon: "error",
      confirmButtonText: "OK",
      customClass: {
        title: "title-class",
        icon: "icon-class",
        confirmButton: "my-button-class",
        cancelButton: "my-button-class",
      },
    });
  },
  warning: ({ title = "Warning", message, html, navigate }) => {
    return Swal.fire({
      title: title,
      text: message,
      html: html,
      icon: "warning",
      confirmButtonText: "OK",
      customClass: {
        icon: "icon-class",
        confirmButton: "my-button-class",
        cancelButton: "my-button-class",
        title: "title-class",
      },
    }).then((result) => {
      if (result.isConfirmed && navigate) {
        window.location.href = navigate;
      } else if (navigate) {
        window.location.href = navigate;
      }
    });
  },

  success: (options) => {
    const { title = "Success", message = "", html, onConfirm, confirmButtonText = "OK" } = options || {};
    return Swal.fire({
      title: title,
      text: message,
      html: html,
      icon: "success",
      confirmButtonText: confirmButtonText,
      customClass: {
        title: "title-class",
        icon: "swal2-icon",
        content: "my-content-class",
        htmlContainer: "my-html-container-class",
        icon: "icon-class",
        confirmButton: "my-button-class",
        cancelButton: "my-button-class",
      },
      //iconHtml: '<i class="my-icon-class fas fa-check-circle"></i>',
      //html: '<div class="my-html-container-class"><div class="title-class">Custom Title</div><div class="my-content-class">Custom Text</div><div class="my-icon-class"></div></div>',
    }).then((result) => {
      if (result.isConfirmed) {

      }
    });
  },

  info: ({ title, message, html }) => {
    return Swal.fire({
      title: title,
      text: message,
      html: html,
      icon: "info",
      confirmButtonText: "OK",
      customClass: {
        icon: "icon-class",
        title: "title-class",
        confirmButton: "my-button-class",
        cancelButton: "my-button-class",
      },
    });
  },
  another: ({
    title,
    message,
    html,
    icon,
    confirmButtonColor,
    showCancelButton,
    cancelButtonColor,
    confirmButtonText,
    cancelButtonText,
    onConfirm,
  }, callback) => {
    return Swal.fire({
      title: title,
      text: message,
      html: html,
      icon: icon,
      showCancelButton: showCancelButton,
      confirmButtonColor: confirmButtonColor,
      cancelButtonColor: cancelButtonColor,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      reverseButtons: true,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      customClass: {
        icon: "icon-class",
        title: "title-class",
        content: "my-text-class",
        confirmButton: "my-button-class",
        cancelButton: "my-button-cance-class",
      },
      preConfirm: () => {
        if (onConfirm) {
          return new Promise(async (resolve, reject) => {
            try {
              let icon = Swal.getIcon();
              if (icon) {
                icon.innerHTML = ` <div class="spinner-border" style="width: 5rem; height: 5rem; border-width: 0.5rem; color: #787878 !important;" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>`;
                icon.style.setProperty("border-color", "white", "important");
              }
              resolve(await onConfirm());
            } catch (error) {
              resolve(error);
            }
          });
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (typeof callback === 'function') {
          callback();
        }
      }
    });
  },

  loading: (props) => {
    return Swal.fire({
      iconColor: "white",
      iconHtml: ` <div class="spinner-border" style="width: 5rem; height: 5rem; border-width: 0.5rem; color: #787878 !important;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>`,
      title: props?.title,
      text: props?.message,
      html: props?.html,
      showConfirmButton: false,
      // allowOutsideClick: false
    });
    // Swal.showLoading()
  },

  ConfirmFooterMessage: ({
    title = "Confirm",
    message,
    html,
    confirmButtonText = "OK",
    cancelButtonText = "Cancel",
    onConfirm,
  }) => {
    return Swal.fire({
      title: title,
      text: message,
      html: html,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      reverseButtons: true,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      customClass: {
        icon: "icon-class",
        title: "title-class",
        content: "my-text-class",
        text: 'white-space-pre-line',
        // confirmButton: "my-button-class",
        // cancelButton: "my-button-class",
        confirmButton: "my-button-class",
        cancelButton: "my-button-cance-class",
      },
      allowOutsideClick: false,
      preConfirm: () => {
        if (onConfirm) {
          return new Promise(async (resolve, reject) => {
            try {
              let icon = Swal.getIcon();
              if (icon) {
                icon.innerHTML = ` <div class="spinner-border" style="width: 5rem; height: 5rem; border-width: 0.5rem; color: #787878 !important;" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>`;
                icon.style.setProperty("border-color", "white", "important");
              }
              resolve(await onConfirm());
            } catch (error) {
              resolve(error);
            }
          });
        }
      },
    });
  },
  close: () => Swal.close(),
};
export default MessageAlert;
